import React, { useState } from "react";
import BackButton from "components/Button/BackButton";
import SaveButton from "components/Button/SaveButton";
import { useNavigate } from "react-router-dom";
import { ModalTypeConfirmation, ModalTypeFail, ModalTypeLoading, ModalTypeSuccess } from "utils/Constant";
import { useModal } from "components/modal/ModalContext";
import { useCallApi } from "api/apiHooks";
import { CheckResponse } from "utils/helpers";
import { PagesFormTitle, PagesTitle } from "components/Cards";

export default function BrandForm(){
    let navigate = useNavigate()
    const { openModal, closeModal } = useModal()
    const { fetchCreateBrand } = useCallApi()

    const [brandName, setBrandName] = useState('')
    
    // Button Event
    const saveBtnClick = () => {
        if(validation()){
            openModal(ModalTypeConfirmation, {
                onConfirm: () => {
                    openModal(ModalTypeLoading)
    
                    fetchCreateBrand(brandName).then((res) => {
                        if (CheckResponse(res)) {
                            openModal(ModalTypeSuccess, {
                                onSuccess: () => {
                                    closeModal()
                                    navigate("/brand") 
                                }
                            })
                        } else {
                            openModal(ModalTypeFail, { message: res.message })
                        }
                    })
                }
            })
        }
    }
    const backBtnClick = () => {
        navigate(-1)
    }

    const validation = () => {
        if (brandName === null || brandName === ''){
            openModal(ModalTypeFail, { message: 'Brand Name is required!' })
            return false
        }

        return true
    }

    return(
        <div className="flex p-3 min-h-full w-full">
            <div className="flex flex-col w-full justify-between gap-2 sm:bg-white sm:p-6 sm:rounded-xl sm:shadow-lg min-h-full">
                <div>
                    <PagesTitle title='Brand Detail' />

                    <div className="mt-5 flex flex-col gap-3 ">
                        {/* Brand Name */}
                        <div className="">
                            <div className="flex flex-col sm:flex-row sm:items-center">
                                <div className="w-48">
                                    <span>Brand Name</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    <input className="input" value={ brandName } onChange={(e) => { setBrandName(e.target.value.toUpperCase()) }} maxLength={40} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                

                {/* Button */}
                <div className="mt-5 flex flex-wrap justify-end gap-2">
                    <SaveButton onClick={saveBtnClick} visible={true} />
                    <BackButton onClick={backBtnClick} />
                </div>
            </div>
        </div>
        
    )
}